export interface PlatformDetails {
    allowedVersion: string;
    invalidVersionTooltip: string;
}

export class AndroidDetails implements PlatformDetails {
    private static _specifics: AndroidDetails;
    public allowedVersion = '7.0';
    public invalidVersionTooltip = 'chat_AndroidInvalidOSVersion_Caption';
    
    static getPlatformSpecifics() {
        if (!AndroidDetails._specifics) {
            AndroidDetails._specifics = new AndroidDetails();
        }
        return AndroidDetails._specifics;
    }
}

export class WindowsDetails implements PlatformDetails {
    private static _specifics: WindowsDetails;
    public allowedVersion = '10.0';
    public invalidVersionTooltip = 'chat_WindowsInvalidOSVersion_Caption';

    static getPlatformSpecifics() {
        if (!WindowsDetails._specifics) {
            WindowsDetails._specifics = new WindowsDetails();
        }
        return WindowsDetails._specifics;
    }
}